import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { setNoIndex } from '../utils/seo';
/**
 * Catch-all route. Previously an unmatched URL rendered a blank page, which
 * search engines treat as a soft 404. This gives crawlers (and visitors) a real
 * page with working links, explicitly marked noindex.
 */
export function NotFoundPage() {
  useEffect(() => {
    document.title = "Page Not Found | Mike's Pro Detail";
    setNoIndex("This page doesn't exist. Explore mobile car detailing services from Mike's Pro Detail in Ventura County, or call (818) 381-9905.");
  }, []);
  return <main className="min-h-screen w-full bg-black text-white selection:bg-red-600 selection:text-white" data-id="element-1092" data-mp="3gpifjy42d7ru">
      <Navigation data-id="element-1093" data-mp="3bqfcgj7n9bmi" />
      <section className="pt-40 pb-24 px-4" data-id="element-1094" data-mp="1mdk2fl2mvrqo">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1095" data-mp="1med4w9uk7v30">
          <h1 className="text-4xl md:text-5xl font-black uppercase tracking-tight mb-6" data-id="element-1096" data-mp="1heqsg2mk2iv9">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-yellow-300 via-yellow-400 to-yellow-500" data-id="element-1097" data-mp="wbz6tke4wjif">
              Page Not Found
            </span>
          </h1>
          <div className="h-1 w-24 bg-red-600 rounded-full shadow-[0_0_10px_rgba(220,38,38,0.8)] mx-auto mb-6" data-id="element-1098" data-mp="10b7y8ilpc5at" />
          <p className="text-lg text-gray-400 mb-10" data-id="element-1099" data-mp="1a3dpfq44qioy">
            The page you're looking for doesn't exist. Head back home or explore
            our mobile detailing services.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1100" data-mp="1f4td7pxoz3b1">
            <Link to="/" className="px-8 py-4 bg-red-600 hover:bg-red-700 text-white font-bold text-lg uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto text-center" data-id="element-1101" data-mp="1k3nzx2ys5c0f">
              Back to Home
            </Link>
            <Link to="/services/mobile-detailing" className="px-8 py-4 bg-white text-black hover:bg-gray-200 font-bold text-lg uppercase tracking-wider rounded-sm transition-colors w-full sm:w-auto text-center" data-id="element-1102" data-mp="3pv1j9cnujv3j">
              Our Services
            </Link>
          </div>
        </div>
      </section>
    </main>;
}